import { render } from "./SetAccount.vue?vue&type=template&id=080ddfac"
import script from "./SetAccount.vue?vue&type=script&lang=js"
export * from "./SetAccount.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bogdanov.ea/Documents/goast-auth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__